import type { AdProps } from "src/components/ads/AdProps";
import FilmwebAd from "src/components/ads/FilmwebAd";
import KinodkAd from "src/components/ads/KinodkAd";

const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Component]
export default function Ad({ targetId, className, supportsFixedAd = false, canHide = false, removeIfNoAd = false, height, mobileScreenWidth = false, isPixel = false, noHeader = false, refreshKey, style }: AdProps) {
    if (BRAND === "kinodk") {
        return <KinodkAd targetId={targetId} className={className} supportsFixedAd={supportsFixedAd} canHide={canHide} removeIfNoAd={removeIfNoAd} height={height} mobileScreenWidth={mobileScreenWidth} isPixel={isPixel} noHeader={noHeader} refreshKey={refreshKey} style={style} />
    }
    return <FilmwebAd targetId={targetId} className={className} supportsFixedAd={supportsFixedAd} canHide={canHide} removeIfNoAd={removeIfNoAd} height={height} mobileScreenWidth={mobileScreenWidth} isPixel={isPixel} noHeader={noHeader} refreshKey={refreshKey} style={style} />
}
//#endregion
